//hooks
import { UserConsumer } from '../../hooks/context/UserContext';

//mui
import { Card, DialogProps } from '@mui/material'

//mui icon
import ReportIcon from '@mui/icons-material/Report';
import EditIcon from '@mui/icons-material/Edit';

//type
import { Claim } from '../../api/Host/type/ClaimsType'

//utilis
import { formatDateTimeUTC } from '../../utils/formatDateTime'

//translate
import { useTranslation } from "react-i18next";
import i18n from "../../translate/i18n";

interface claimCardProps {
    element: Claim,
    setOpenUpdateClaimDilaog: (value: {open:boolean,scrollType: DialogProps['scroll']}) => void
    setSelectedClaim: (selectedClaim: Claim | null) => void
    setSelectedButton?: (selectedButton: string) => void
    type?: string
}

const ClaimCard = ({element, setOpenUpdateClaimDilaog, setSelectedClaim, setSelectedButton, type}:claimCardProps) => {
    const {t} = useTranslation()
    let {theme} = UserConsumer()
    return (
        <Card className="border rounded-base shadow-xs" key={element.id}>
            <div className='p-6'>
                <ReportIcon className={`${theme === "client" ? "!text-customerColor" : "!text-paretnerColor"} !text-[40px] mb-3`}/>
                <div className='flex justify-between items-center mb-2 font-semibold'>
                    <h5 className="text-2xl">{formatDateTimeUTC(element.updated_at).date}</h5>
                    <h5 className="text-sm">{formatDateTimeUTC(element.updated_at).time}</h5>
                </div>
                <p className="mb-3">{element.comment}</p>
            </div>
            <div className='flex justify-between mt-2 p-3'>
                <div
                onClick={()=>{setOpenUpdateClaimDilaog({open:true,scrollType: "paper"}); setSelectedButton?.("edit"); setSelectedClaim(element)}}
                className={`cursor-pointer ${type === undefined ? "" : "hidden"} flex items-center gap-2 border-[1px] border-solid border-[#0073E6] text-[#0073E6] px-3 rounded-md`}>
                    <EditIcon className='!text-[15px]'/>
                    <p>{t("edit")}</p>
                </div>
                <div
                onClick={()=>{setOpenUpdateClaimDilaog({open:true,scrollType: "paper"}); setSelectedButton?.("view"); setSelectedClaim(element)}}
                className={`cursor-pointer flex gap-2 border-[1px] border-solid ${theme === "client" ? "border-customerColor text-customerColor" : "border-paretnerColor text-paretnerColor"} text-${theme === "client" ? "customerColor" : "paretnerColor"} px-3 rounded-md`}>
                    <p>{t("view_details")}</p>
                </div>
            </div>
        </Card>
    )
}

export default ClaimCard